import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {GatewayEnvironment} from "../model/gateway/gatewayEnvironment";

@Injectable({
  providedIn: 'root'
})
export class GatewayEnvironmentService {

  private readonly API_PREFIX = environment.apiUrlGatewayEnvPrefix;

  private http = inject(HttpClient);

  public findAllActive(): Observable<GatewayEnvironment[]> {
    return this.http.get<GatewayEnvironment[]>(this.API_PREFIX + 'active');
  }
}
